export default __webpack_public_path__ + "static/media/img_step_lucia03-13.baa42a32.jpg";